<template>
    <el-main>
        <!-- Bread crumb -->
        <div class="menuBox">
            <el-breadcrumb separator-class= none>
                <el-breadcrumb-item :to="{ name: '홈' }" ><img src="@/components/image/home.png"/></el-breadcrumb-item>
                <el-breadcrumb-item v-for="item in realList" :key="item.path" :replace="true">
                    &nbsp;
                    <img class="image" v-if="item.name != null" src="@/components/image/right-arrow.png"/>
                    {{item.name}} 
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </el-main>
</template>

<script>
export default {
    name: "menuBox",
    created(){
        this.getRoutePath(this.$route.matched);
    },
    data() {
        return {
            realList: []
        }
    },
    watch: {
        $route(route) {
            this.getRoutePath(route.matched);
        }
    },
    methods:{
        getRoutePath(matched){
            const list = matched.filter((item) => {
                return !item.meta.notBreadcrumb;
            });
            list.forEach((item) => {
                if(item.redirect) {
                    item.toPath = item.redirect;
                } else {
                    item.toPath = item.path;
                } 
            });
            this.realList = list;

            if(this.realList[1].name == "정기권 신청") {
                this.realList[2].name = null;
            } else if(this.realList[1].name == "시간권 구매") {
                this.realList[2].name = null;
            } else if(this.realList[1].name == "주차장 안내") {
                this.realList[2].name = null;
            } else if(this.realList[0].name == "사이트맵") {
                this.realList[1].name = null;
            }
        }
    },
    mounted() {
        this.$store.state.popupCheck = true;
    }
}
</script>

<style scoped>
@import '@/assets/css/reset.css';
    .el-main {
        margin: auto;
        padding: 0;
        width: 100% !important;
        align-items: center;
        /* margin-top: 2.3%; */
    }
    .menuBox {
        margin: auto;
        /* padding-left: 1%; */
        height: 30px;
        max-width: 1197px;
        width: 90%;
        text-align: left;
        color: black;
        font: normal normal 14px/20px Noto Sans KR-BOLD;
    }

    img {
        width: 16px;
        height: 14px;
    }

    .image {
        width:10px; 
        height:10px;
        /* padding-right: 0.1%; */
    }

    /* 반응형 웹 CSS */
    @media all and (max-width: 1474px) {
        .menuBox {
            display: none;
        }
    }

    @media all and (min-width: 1920px) {

        .menuBox {
            max-width: 1180px;
        }

    }

    
</style>